var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPage500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 263.066,
    height: 268.785,
    viewBox: "0 0 263.066 268.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_2_",
    "data-name": "download (2)",
    transform: "translate(-163.26 -158.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M375.127,348.25H315.08a20.016,20.016,0,1,0,0,40.033h60.047a20.016,20.016,0,1,0,0-40.033Zm0,28.592H315.08a8.578,8.578,0,0,1,0-17.157h60.047a8.578,8.578,0,1,1,0,17.157Z",
    transform: "translate(-50.314 -72.384)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M298.321,177.13A125.811,125.811,0,1,0,424.132,302.941,125.746,125.746,0,0,0,298.321,177.13Zm0,240.184A114.373,114.373,0,1,1,412.694,302.941,114.5,114.5,0,0,1,298.321,417.314Z",
    transform: "translate(-3.531 -7.062)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M315.976,223.38A97.216,97.216,0,1,0,413.193,320.6,97.327,97.327,0,0,0,315.976,223.38Zm0,183A85.785,85.785,0,1,1,401.761,320.6,85.882,85.882,0,0,1,315.976,406.381Z",
    transform: "translate(-21.186 -24.717)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M335.765,461.184a63.154,63.154,0,0,1-54.495-31.457,5.719,5.719,0,0,0-9.9,5.726,74.626,74.626,0,0,0,64.4,37.168,5.719,5.719,0,1,0,0-11.438Z",
    transform: "translate(-40.975 -102.397)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M422.036,279.311a74.2,74.2,0,0,0-49.565-18.932,5.719,5.719,0,0,0,0,11.438,62.789,62.789,0,0,1,41.936,16.017,5.719,5.719,0,0,0,7.63-8.523Z",
    transform: "translate(-77.68 -38.841)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M180.417,510.12a17.157,17.157,0,1,0,17.157,17.157A17.177,17.177,0,0,0,180.417,510.12Zm0,22.876a5.719,5.719,0,1,1,5.719-5.719A5.725,5.725,0,0,1,180.417,533Z",
    transform: "translate(0 -134.175)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M537.626,204.382a22.876,22.876,0,1,0-22.876-22.876A22.9,22.9,0,0,0,537.626,204.382Zm0-34.314a11.438,11.438,0,1,1-11.438,11.438A11.451,11.451,0,0,1,537.626,170.068Z",
    transform: "translate(-134.175)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M572.428,488.089a5.719,5.719,0,1,1-5.719-5.719,5.718,5.718,0,0,1,5.719,5.719",
    transform: "translate(-151.827 -123.582)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M535.438,562.09a5.719,5.719,0,1,1-5.719-5.717,5.718,5.718,0,0,1,5.719,5.717",
    transform: "translate(-137.706 -151.832)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M257.948,580.589a5.719,5.719,0,1,1-5.719-5.719,5.72,5.72,0,0,1,5.719,5.719",
    transform: "translate(-31.779 -158.893)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M248.7,182.849a5.719,5.719,0,1,1-5.719-5.719,5.72,5.72,0,0,1,5.719,5.719",
    transform: "translate(-28.248 -7.062)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M183.948,247.6a5.719,5.719,0,1,1-5.719-5.719,5.72,5.72,0,0,1,5.719,5.719",
    transform: "translate(-3.531 -31.779)",
    fill: "#d0d2d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M572.428,266.1a5.719,5.719,0,1,1-5.719-5.717,5.718,5.718,0,0,1,5.719,5.717",
    transform: "translate(-151.827 -38.843)",
    fill: "#d0d2d5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage500);
export default __webpack_public_path__ + "static/media/page500.650cad6244898a229076bb4feeb2df9c.svg";
export { ForwardRef as ReactComponent };